import type { NextPage } from 'next'
import { LabelLibrary } from '@/client/modules/LabelLibrary'
import { IPersonalInfos } from '@/client/modules/PersonalInfos/types'
import { getCMSContent } from '@/client/utils'
import { IRoutes } from '@/client/utils/routes/types'

const FavouriteFiles: NextPage<IPersonalInfos> = (data) => <LabelLibrary {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, IRoutes.LABEL_LIBRARY)

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default FavouriteFiles
